export default (theme) => ({
  container: {
    padding: 5,
    display: "flex",
  },
  futura: {
    fontFamily: "Futura-Bold",
  },
});
